import type { ILocale } from './';

export default {
  notification: {
    closeLabel: 'Close'
  },
  table: {
    filterTitle: 'Filter menu',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    filterEmptyText: 'No filters',
    filterCheckAll: 'Select all items',
    filterSearchPlaceholder: 'Search in filters',
    emptyText: 'No data',
    selectAll: 'Select current page',
    selectInvert: 'Invert current page',
    selectNone: 'Clear all data',
    selectionAll: 'Select all data',
    sortTitle: 'Sort',
    expand: 'Expand row',
    collapse: 'Collapse row',
    triggerDesc: 'Click to sort descending',
    triggerAsc: 'Click to sort ascending',
    cancelSort: 'Click to cancel sorting',
    showed: 'Showed',
    from: 'from',
    rowOnPage: 'Row on page'
  },
  date: {
    days: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    daysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    monthsLong: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    today: 'Today',
    firstDayOfWeek: 0, // 0-6, 0 - Sunday, 1 Monday, ...
    format24h: false,
    pluralDay: () => 'days'
  },
  time: {
    now: 'Current time'
  },
  container: {
    prev: 'Previous',
    next: 'Next'
  },
  slideView: {
    prev: 'Previous',
    next: 'Next'
  },
  uploader: {
    uploading: 'Uploading',
    uploadFile: 'Upload file',
    downloadFile: 'Download file',
    removeFile: 'Remove file',
    uploadError: 'Upload error',
    previewFile: 'Preview file'
  },
  dropdown: {
    noData: 'No data',
    selectAll: 'Select all'
  }
} as ILocale;
